"use client";

import RivalsTable from "rivals/components/shared/Tables/RivalsTable";
import styles from "./TableBlock.module.scss";
import { Props } from "./types";

function TableBlock({
  caption,
  content,
  headers,
  title
}: Props): React.JSX.Element {
  interface Column {
    dataIndex: string;
    key: string;
    title: string;
  }

  interface Data {
    [k: string]: string | number;
  }

  const columns = headers.reduce<Column[]>(
    (cols, header, i) => [
      ...cols,
      { dataIndex: i.toString(), key: i.toString(), title: header.name }
    ],
    []
  );

  const data = content.reduce<Data[]>(
    (rows, row, i) => [
      ...rows,
      row.reduce(
        (r, field, j) => ({
          ...r,
          [columns[j]["key"]]: (
            <div
              className={styles.cell}
              dangerouslySetInnerHTML={{ __html: field.value }}
            />
          )
        }),
        { key: i }
      )
    ],
    []
  );

  return (
    <div className={styles.tableContainer}>
      <div className={styles.titleContainer}>
        <div className={styles.tableTitle}>{title}</div>
        {caption && <div className={styles.tableCaption}>{caption}</div>}
      </div>
      <RivalsTable<Data>
        className={styles.table}
        columns={columns}
        data={data || []}
        philter={`table-${title}`}
        rowKey="key"
        stripedRows
        tableKey={title}
      />
    </div>
  );
}

export default TableBlock;
